import * as LEVELS from './constants';

const state = {
	categories: [],
	changeListeners: [],
};

export const set = (cats) => {
	const newCats = cats.map(k => k.toUpperCase()).filter(a => LEVELS[a]);
	state.categories = newCats;
	// powsterOneTrust should not be set in this file
	// a onetrust specific file should use addChangeListener for this
	window.powsterOneTrust = [...newCats];
	state.changeListeners.forEach(listener => listener(state.categories));
	window.dispatchEvent(new CustomEvent('powster-categories-update', { detail: state.categories }));
};

export const get = () => state.categories;
export const has = category => state.categories.includes(category);

export const getChangeListeners = () => state.changeListeners;

export const addChangeListener = (fn) => {
	state.changeListeners.push(fn);
};
export const removeChangeListener = (fn) => {
	state.changeListeners = state.changeListeners.filter(a => a !== fn);
};

export const toString = () => state.categories.join(',');
